import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  getOAuthApps,
  getOAuthConsentClient,
  getTrustDeviceStatus,
  revokeOAuthApp,
  untrustDevice,
} from "@/lib/api/security";

export function useOAuthApps() {
  const { data, isLoading } = useQuery({
    queryKey: ["oauth-apps"],
    queryFn: getOAuthApps,
  });
  return { apps: data ?? [], isLoading };
}

export function useOAuthConsentClient(clientId: string | null, redirectUri: string | null) {
  return useQuery({
    queryKey: ["oauth-consent-client", clientId, redirectUri],
    queryFn: () => getOAuthConsentClient(clientId ?? "", redirectUri ?? ""),
    enabled: !!clientId && !!redirectUri,
  });
}

export function useRevokeOAuthApp() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: revokeOAuthApp,
    onSuccess: () => qc.invalidateQueries({ queryKey: ["oauth-apps"] }),
  });
}

export function useTrustDeviceStatus() {
  return useQuery({
    queryKey: ["trust-device"],
    queryFn: getTrustDeviceStatus,
  });
}

export function useUntrustDevice() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: untrustDevice,
    onSuccess: () => qc.invalidateQueries({ queryKey: ["trust-device"] }),
  });
}
